import styled from "styled-components";

const Container = styled.div`
  margin: 50px 0;
`;
export default Container;
